import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Preloader from "../layouts/Preloader";
import Login from "../pages/auth/Login";
import CategoryComponent from "../pages/categories/CategoryComponent";
import SellersComponent from "../pages/sellers/SellersComponent";
import RewardsLevelsComponent from "../pages/rewards/RewardsLevelsComponent";
import RewardsHistoryComponent from "../pages/rewards/RewardsHistoryComponent";
import NoMatch from "../pages/errors/NoMatch";
import MasterLayouts from "../layouts/MasterLayouts";
import AuthLayouts from "../layouts/AuthLayouts";
import Home from "../pages/Home";
import RewardsEventTypesComponent from "../pages/rewards/RewardsEventTypesComponent";
import RewardsPrizesComponent from "../pages/rewards/RewardsPrizesComponent";
import RewardsGroupsComponent from "../pages/rewards/RewardsGroupsComponent";
import InviteTenantsComponent from "../pages/sellers/InviteTenantsComponent";
import ProductAttachmentsComponent from "../pages/products/ProductAttachments";

const Router = () => {
  return (
    <Suspense fallback={<Preloader />}>
      <Routes>
        <Route path="/" element={<MasterLayouts />}>
          <Route path="/home" element={<Home />} />
          <Route path="category" element={<CategoryComponent />} />
          <Route path="category/:categoryId" element={<CategoryComponent />} />
          <Route path="category-group/:categoryGroup" element={<CategoryComponent />} />
          <Route path="sellers" element={<SellersComponent />} />
          <Route path="analytics/transactions" element={<RewardsHistoryComponent />} />
          <Route path="rewards/event-types" element={<RewardsEventTypesComponent />} />
          <Route path="rewards/levels" element={<RewardsLevelsComponent />} />
          <Route path="rewards/items" element={<RewardsPrizesComponent />} />
          <Route path="rewards/groups" element={<RewardsGroupsComponent />} />
          <Route path="tenant-invites" element={<InviteTenantsComponent />} />
          <Route path="product-attachments" element={<ProductAttachmentsComponent />} />
          <Route path="*" element={<NoMatch />} />
        </Route>
        <Route path="/auth" element={<AuthLayouts />}>
          <Route index element={<Login />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default Router;
